

const ENBusinessDiagnosticsModels = {
	"Adicionar modelo de diagnóstico": "Add diagnostic model",
	"Adicionar Critério": "Add Criteria",
	"Adicionar Resposta": "Add Answer",
	"Adicionar Questão": "Add Question",
	"Alterar modelo de diagnóstico": "Update diagnostic model",
	"Alterar Critério": "Update Criteria",
	"Alterar Resposta": "Update Answer",
	"Alterar Questão": "Update Question",
	"Critério": "Criteria",
	"Critério adicionado com sucesso": "Criteria successfully added",
	"Critério alterado com sucesso": "Criteria successfully updated",
	"Critério excluído com sucesso": "Criteria deleted successfully",
	"Critério movido com sucesso": "Criteria moved successfully",
	"Conceito": "Concept",
	"Digite o título do modelo de diagnóstico para excluí-lo": "Enter the title of the diagnostic model to delete it",
	"Deseja realmente excluir a resposta": "Do you really want to delete the answer",
	"Deseja realmente excluir o critério": "Do you really want to delete the criteria",
	"Deseja realmente excluir o modelo de diagnóstico": "Do you really want to delete the diagnostic model",
	"Deseja realmente excluir a questão": "Do you really want to delete the question",
	"Editar Critério": "Edit Criteria",
	"Editar Questão": "Edit Question",
	"Este modelo de diagnóstico já foi utilizado, algumas ações estarão desabilitadas": "This diagnostic model has already been used, some actions will be disabled",
	"Erro ao adicionar critério": "Error adding criteria",
	"Erro ao adicionar modelo de diagnóstico": "Error adding diagnostic model",
	"Erro ao adicionar resposta": "Error adding answer",
	"Erro ao adicionar questão": "Error adding question",
	"Erro ao alterar critério": "Error updating criteria",
	"Erro ao alterar modelo de diagnóstico": "Error updating diagnostic model",
	"Erro ao alterar resposta": "Error updating answer",
	"Erro ao alterar questão": "Error updating question",
	"Erro ao mover critério": "Error moving criteria",
	"Erro ao mover questão": "Error moving question",
	"Erro ao mover resposta": "Error moving answer",
	"Erro ao carregar critério": "Error loading criteria",
	"Erro ao carregar modelos de diagnóstico": "Error loading diagnostic models",
	"Erro ao excluir critério": "Error deleting criteria",
	"Erro ao excluir modelo de diagnóstico": "Error deleting diagnostic model",
	"Erro ao excluir questão": "Error deleting question",
	"Exclusão da critério": "Deleting criteria",
	"Exclusão da resposta": "Deleting answer",
	"Exclusão da questão": "Deleting question",
	"Excluir Critério": "Delete Criteria",
	"Excluir Questão": "Delete Question",
	"Exclusão de modelo de diagnóstico": "Deleting diagnostic model",
	"Modelo de diagnóstico excluído com sucesso": "Diagnostic model deleted successfully",
	"Modelo de diagnóstico": "Diagnostic model",
	"Nenhum critério encontrado": "No criteria found",
	"Nenhuma questão encontrada": "No question found",
	"Nenhuma resposta encontrada": "No answer found",
	"Nenhum modelo de diagnóstico selecionado": "No diagnostic model selected",
	"Novo Critério": "New Criteria",
	"Novo modelo de diagnóstico": "New diagnostic model",
	"Modelos de Diagnóstico": "Diagnostic Models",
	"Mover Critério": "Move Criteria",
	"Mover Resposta": "Move Answer",
	"Mover Questão": "Move Question",
	"Titulo do modelo de diagnóstico não confere": "Title of the diagnostic model does not match",
	"Pontuação": "Score",
	"Pontuação é requerida": "Score is required",
	"Questão": "Question",
	"Questão adicionada com sucesso": "Question successfully added",
	"Questão alterada com sucesso": "Question successfully updated",
	"Questão excluída com sucesso": "Question deleted successfully",
	"Questões": "Questions",
	"Questão é requerida": "Question is required",
	"Questão movida com sucesso": "Question moved successfully",
	"Respostas": "Answers",
	"Resposta adicionado com sucesso": "Answer successfully added",
	"Resposta alterado com sucesso": "Answer successfully updated",
	"Resposta excluída com sucesso": "Answer deleted successfully",
	"Resposta movida com sucesso": "Answer moved successfully"
};


export default ENBusinessDiagnosticsModels;
